/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notificationcenter_Dismiss1Inputs */

const en_notificationcenter_dismiss1 = /** @type {(inputs: Notificationcenter_Dismiss1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss notification`)
};

/**
* | output |
* | --- |
* | "Dismiss notification" |
*
* @param {Notificationcenter_Dismiss1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const notificationcenter_dismiss1 = /** @type {((inputs?: Notificationcenter_Dismiss1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notificationcenter_Dismiss1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_notificationcenter_dismiss1(inputs)
});
export { notificationcenter_dismiss1 as "notificationCenter_dismiss" }